// frontend-dash/src/pages/EditBlogPost.js
// Redirects to the unified WYSIWYG blog editor at /edit/blog/:id
import { Navigate, useParams } from 'react-router-dom';

const EditBlogPost = () => {
    const { id } = useParams();
    return <Navigate to={`/edit/blog/${id}`} replace />;
};

export default EditBlogPost;
